import { owaComputedFn } from "owa-computed-fn";
import { getEnterpriseOrPremiumLicenseStatus } from "./getEnterpriseOrPremiumLicenseStatus";

/**
 * This function returns `true` if the user has any account that is a paid (Enterprise + Premium/Paid consumer) amongst their accounts.
 * If all of the user's accounts are consumer (non-paid), then the function will return `false`.
 */
export const hasPaidAccount: () => boolean = owaComputedFn(function hasPaidAccount(): boolean {
    return getEnterpriseOrPremiumLicenseStatus() == "HasEnterpriseOrPremiumLicense";
});
